import type { ReactNode } from "react";
import { Navigate, useLocation } from "react-router-dom";

import { useAuth } from "../lib/auth";
import Skeleton from "./states/Skeleton";

/**
 * Wraps protected routes (MER-115 Phase 5 acceptance: every
 * `/customer` route checks session, redirects to `/login` if
 * missing). The redirect preserves the original target via router
 * `state.from` so the post-login flow lands on the requested page.
 */
export default function AuthGate(props: { children: ReactNode }) {
  const { session, isLoading } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return (
      <main style={{ padding: 32, display: "grid", placeItems: "center", minHeight: "60vh" }}>
        <Skeleton label="Checking session" height={80} />
      </main>
    );
  }

  if (!session) {
    return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  }

  return <>{props.children}</>;
}
